import { z } from 'zod';

/////////////////////////////////////////
// CORE COMMUNICATION INSTAGRAM SEND ATTEMPT SCHEMA
/////////////////////////////////////////

export const CoreCommunicationInstagramSendAttemptSchema = z.object({
  coreCommunicationSendAttemptId: z.number().int(),
  instagramIntegrationId: z.bigint(),
  instagramPostId: z.string().nullable(),
})

export type CoreCommunicationInstagramSendAttempt = z.infer<typeof CoreCommunicationInstagramSendAttemptSchema>

export default CoreCommunicationInstagramSendAttemptSchema;
